import DataCleaner from './clean/DataCleaner.js';
import { isNumber, flatten, compact, map, cloneDeep } from 'lodash';
import Partutil from './partutil.js';
const uuid = require('uuid');

const ROOT = {id:'root'}

function GameData(gamedata={scenes:[],toybox:[],features:[]}, skipConversion=false) {
  //this.gamedata = DataCleaner(gamedata);
  this.gamedata = gamedata;
  this.variables = gamedata.variables || [];

  if (typeof(this.gamedata.uploadedImages) === 'undefined') {
    this.gamedata.uploadedImages = [];
  }

  if (!skipConversion) {
    this.convertToVersion2();
    this.convertToVersion3();
    this.convertToVersion4();
    this.convertToVersion5();
    this.convertToVersion6();
    this.convertToVersion7();
  }
}

function convertStringToNumber(str) {
  if (isNumber(str)) {
    return str;
  }
  return parseFloat(str);
}
GameData.prototype.cleanBuildData = function () {
  delete this.gamedata.build;
}
GameData.prototype.clean = function () {
  return this.gamedata;
  return cloneDeep(this.gamedata);
  //return DataCleaner(cloneDeep(this.gamedata));
}

GameData.prototype.getTransformById = function (id) {
  return this.findAllTransforms().filter( (t) => {
    return t.id === id;
  })[0];
}

GameData.prototype.convertToVersion7 = function () {
  if (typeof(this.gamedata.version) !== 'undefined' && this.gamedata.version >= 7) {
    return;
  }
  this.gamedata.version = 7;

  (this.gamedata.uploadedImages||[]).forEach( (file) => {
    file.__type = 'image';
  });
}

GameData.prototype.convertToVersion6 = function () {
  if (typeof(this.gamedata.version) !== 'undefined' && this.gamedata.version >= 6) {
    return;
  }
  this.gamedata.version = 6;

  this.gamedata.scenes.forEach( (scene) => {
    Object.values(scene.layers).forEach( (layer) => {
      if (typeof(layer.components) === 'undefined') {
        layer.components = [];
        layer.links = [];
      }
    });
  });

  this.gamedata.toybox.forEach( (toy) => {
    Object.values(toy.layers).forEach( (layer) => {
      if (typeof(layer.components) === 'undefined') {
        layer.components = [];
        layer.links = [];
      }
    });
  });

}

GameData.prototype.convertToVersion5 = function () {
  if (typeof(this.gamedata.version) !== 'undefined' && this.gamedata.version >= 5) {
    return;
  }
  this.gamedata.version = 5;

  this.gamedata.scenes.forEach( (scene) => {
    if (scene.layers.background) {
      scene.layers.background.zindex = -5;
    }
  });

  this.gamedata.toybox.forEach( (toy) => {
    if (toy.layers.background) {
      toy.layers.background.zindex = -5;
    }
  });
}
GameData.prototype.convertToVersion4 = function () {
  if (typeof(this.gamedata.version) !== 'undefined' && this.gamedata.version >= 4) {
    return;
  }
  this.gamedata.version = 4;

  const backgroundLayer = {
    id:'background',
    name:'Background',
    zindex:0
  }
  const textLayer = {
    id:'text',
    name:'Text',
    zindex:5
  }
  const toyLayer = {
    id:'toy',
    name:'Toy',
    zindex:2
  }
  this.gamedata.scenes.forEach( (scene) => {
    scene.layers.background = backgroundLayer;
    scene.layers.text = textLayer;
    scene.layers.toy = toyLayer;

    Object.values(scene.layers).forEach( (layer) => {
      const rootComponent = {
        id:uuid.v4(),
        type:'multiple'
      }
      layer.components = [rootComponent];
      layer.links = [];
    });
  });

  this.gamedata.toybox.forEach( (toy) => {
    toy.layers.background = backgroundLayer;
    toy.layers.text = textLayer;
    toy.layers.toy = toyLayer;
    if (toy.layers.id && toy.layers.id === "default") {
      delete toy.layers.id;
      toy.layers.default = {
        id:"default",
        zindex:1
      }
    }

    Object.values(toy.layers).forEach( (layer) => {
      const rootComponent = {
        id:uuid.v4(),
        type:'multiple'
      }
      layer.components = [rootComponent];
      layer.links = [];
    });
  });

}
GameData.prototype.convertToVersion3 = function () {
  if (typeof(this.gamedata.version) !== 'undefined' && this.gamedata.version >= 3) {
    return;
  }
  this.gamedata.version = 3;

  const allTransforms = this.findAllTransforms();
  allTransforms.forEach( (t) => {
    if (typeof(t.layer) === 'undefined') {
      t.transform.layer = 'default';
    }
  });

  const defaultLayer = {
    id:'default',
    name:'Foreground',
    zindex:1
  }
  this.gamedata.scenes.forEach( (scene) => {
    if (typeof(scene.layers) === 'undefined') {
      scene.layers = {
        default: defaultLayer
      };
    } else {
      if (!scene.layers.default) {
        scene.layers.default = defaultLayer;
      }
    }

  });

  this.gamedata.toybox.forEach( (toy) => {
    if (typeof(toy.layers) === 'undefined') {
      toy.layers = {
        default:defaultLayer
      };
    } else {
      if (!toy.layers.default) {
        toy.layers.default = defaultLayer;
      }
    }

  });

}
GameData.prototype.convertToVersion2 = function () {
  if (typeof(this.gamedata.version) !== 'undefined' && this.gamedata.version >= 2) {
    return;
  }
  this.gamedata.version = 2;
  // fix toy scales from version 1 to version 2
  const toys = this.filterComponentsByType(['toy']);
  const toysAndSource = this.findComponentsAndSourceByFilter(toys);
  const transformsWithToyComponents = this.findTransformsAndSourceForComponentsAndSource(toysAndSource);
  transformsWithToyComponents.forEach( ({transforms}) => {
    transforms.forEach( ({transform}) => {
      transform.localScale.x = transform.scale.x;
      transform.localScale.y = transform.scale.y;
      transform.scale.x = 1;
      transform.scale.y = 1;
    });
  });

  // Fix transforms
  const allTransforms = this.findAllTransforms();
  allTransforms.forEach( (t) => {
    // Fix z-indexes (default is now 1)
    t.transform.zIndex = convertStringToNumber(t.zIndex);
    if (isNaN(t.transform.zIndex)) {
      t.transform.zIndex = 1;
    }

    t.transform.alpha = convertStringToNumber(t.transform.alpha);
    if (isNaN(t.transform.alpha)) {
      t.transform.alpha = 1;
    }

    if (typeof(t.transform.anchor) === "undefined") {
      t.transform.anchor = {
        x: 0.5,
        y: 0.5
      }
    }
    if (typeof(t.transform.localScale) === "undefined") {
      t.transform.localScale = {
        x: 1,
        y: 1
      }
    }
    if (typeof(t.transform.alpha) === "undefined") {
      t.transform.alpha = 1;
    }
    if (typeof(t.transform.disabled) === "undefined") {
      t.transform.disabled = false;
    }
    if (typeof(t.transform.unparent) === "undefined") {
      t.transform.unparent = false;
    }
    if (typeof(t.transform.sendToOrigin === "undefined")) {
      t.transform.sendToOrigin = false;
    }
    
    if (typeof(t.variables) === 'undefined') {
      t.variables = [];
    }

  });
  allTransforms.forEach( (t) => {
    delete t.zIndex;
  });

  // fix toys
  this.gamedata.toybox.forEach( (toy) => {
    if (typeof(toy.variables) === 'undefined') {
      toy.variables = [];
    }
  });

  // fix scenes
  this.gamedata.scenes.forEach( (scene) => {
    if (typeof(scene.variables) === 'undefined') {
      scene.variables = [];
    }
  });

  // move OnEventTransform events to vars
  const onEventTransforms = this.filterComponentsByType(['onEventTransform']);
  const onEventTransformsAndSource = this.findComponentsAndSourceByFilter(onEventTransforms);
  const transformsWithEventComponents = this.findTransformsAndSourceForComponentsAndSource(onEventTransformsAndSource);

  transformsWithEventComponents.forEach( ({c,transforms}) => {
    transforms.forEach( ({children}) => {
      children.forEach( (child) => {
        if (typeof(child.vars) === 'undefined') {
          child.vars = {};
        }
        child.vars.eventName = c.eventName;
      });
    });
  });
  transformsWithEventComponents.forEach( ({c}) => {
    delete c.eventName;
  });

  // move spawner transform to vars
  const spawnerTransforms = this.filterComponentsByType(['spawner']);
  const spawnerTransformsAndSource = this.findComponentsAndSourceByFilter(spawnerTransforms);
  const transformsWithSpawnerComponents = this.findTransformsAndSourceForComponentsAndSource(spawnerTransformsAndSource);

  transformsWithSpawnerComponents.forEach( ({c,transforms}) => {
    let {initialDelay,firetime,probability,times,preSpawn} = c;
    initialDelay = parseFloat(initialDelay);
    firetime = parseFloat(firetime);
    probability = parseFloat(probability);
    times = parseFloat(times);
    preSpawn = parseFloat(preSpawn);

    transforms.forEach( ({children}) => {
      children.forEach( (child) => {
        if (typeof(child.vars) === 'undefined') {
          child.vars = {};
        }
        child.vars.initialDelay = initialDelay;
        child.vars.firetime = firetime;
        child.vars.probability = probability;
        child.vars.times = times;
        child.vars.preSpawn = preSpawn;
      });
    });
  });
  transformsWithSpawnerComponents.forEach( ({c}) => {
    delete c.initialDelay;
    delete c.firetime;
    delete c.probability;
    delete c.times;
    delete c.preSpawn;
  });

}

GameData.prototype.getAllComponentsWithSource = function () {
  let components = [];
  this.gamedata.toybox.forEach( (toy) => {
    components = components.concat(toy.components.map( (c) => {
      return {
        c,
        source:'toy',
        gamedata:this,
        from:toy,
        root:ROOT
      }
    }));
  });
  this.gamedata.scenes.forEach( (scene) => {
    components = components.concat(scene.components.map( (c) => {
      return {
        c,
        source:'scene',
        gamedata:this,
        from:scene,
        root:ROOT
      }
    }));
  });
  if ((this.gamedata.components||[]).length) {
    this.gamedata.components.forEach( (c) => {
      components.push({
        c,
        source:'root',
        gamedata:this,
        from:this.gamedata,
        root:ROOT
      });
    });
  }
  return components;
}

GameData.prototype.findAllTransforms = function () {
  const allTransforms = [];

  if ((this.gamedata.components||[]).length) {
    // TODO: hack for when gamedata source is from
    // a toy in the toy editor
    const hack = {
      from:this.gamedata,
      source:'root',
      gamedata:this,
      root:ROOT
    }
    const partutil = new Partutil(hack);
    partutil.findAllChildren(allTransforms);
  }

  this.gamedata.scenes.forEach( (scene,i) => {
    const partutil = new Partutil(this.getSceneByIndex(i));
    partutil.findAllChildren(allTransforms);
  });
  this.gamedata.toybox.forEach( (toy) => {
    const partutil = new Partutil(this.getToyById(toy.id));
    partutil.findAllChildren(allTransforms);
  });
  return allTransforms;
}

GameData.prototype.getSceneByIndex = function (index) {
  const scene = this.gamedata.scenes[index];
  return {
    source:'scene',
    gamedata:this,
    transforms:scene.transforms,
    from:scene,
    root:ROOT,
  }
}
GameData.prototype.getFeatureByIndex = function (index) {
  const feature = this.gamedata.features[index];
  return {
    source:'feature',
    gamedata:this,
    transforms:[],
    from:feature,
    root:ROOT
  }
}

GameData.prototype.addToy = function (in_toy) {
  const toy = cloneDeep(in_toy);
  this.gamedata.toybox.push(toy);
  return toy;
}
GameData.prototype.getToyByIndex = function (index) {
  const scene = this.gamedata.toybox[index];
  return {
    source:'toy',
    gamedata:this,
    transforms:scene.transforms,
    from:scene,
    root:ROOT
  }
}

GameData.prototype.getAllComponents = function () {
  let components = [];
  this.gamedata.toybox.forEach( (toy) => {
    components = components.concat(toy.components);
  });
  this.gamedata.scenes.forEach( (scene) => {
    components = components.concat(scene.components);
  });
  (this.gamedata.components||[]).forEach( (component) => {
    components.push(component);
  });
  return components;
}


GameData.prototype.findComponentsAndSourceByFilter = function (filter) {
  return this.getAllComponentsWithSource().filter(({c}) => {
    return filter(c);
  });
}

GameData.prototype.findComponentsByFilter = function (filter) {
  return this.getAllComponents().filter(filter);
}

GameData.prototype.filterComponentsByTransform = function (transform) {
  return (c) => {
    return c.id === transform.cid;
  }
}
GameData.prototype.filterComponentsByType = function (types) {
  return (c) => {
    return types.includes(c.type);
  }
}

GameData.prototype.filterTransformsByCid = function (cids) {
  return (t) => {
    return cids.includes(t.cid);
  }
}

GameData.prototype.findComponentAndSource = function (id) {
  return this.getAllComponentsWithSource().filter( ({c,source,from}) => {
    return c.id === id;
  })[0];
}
GameData.prototype.findRootsForComponentAndSource = function ({c,source,from}, first=true) {
  const toHere = from.links.filter( (l) => {
    return l.target === c.id;
  });
  if (!toHere.length) {
    if (first) {
      return [c];
    } else {
      return c;
    }
  } else {
    return flatten(toHere.map( (t) => {
      const {source} = t;
      const component = from.components.filter( (c) => {
        return c.id === source;
      })[0];
      if (!component) {
        // component no longer has a link
        // probably has not yet been garbage collected;
        return null;
      }
      return this.findRootsForComponentAndSource({source,from,c:component}, false);
    }));
  }

}

GameData.prototype.findTransformsAndSourceForComponentsAndSource = function (componentsAndSource) {
  return componentsAndSource.map( ({c,source,from}) => {
    let roots = compact(this.findRootsForComponentAndSource({c,source,from}));
    let transforms = [];
    roots.forEach( (root) => {
      transforms = transforms.concat(this.findTransformsForRootComponentAndSource({
        c:root,
        source,
        gamedata:this,
        from,
        root:ROOT
      }));
    });

    return {
      c,
      source,
      gamedata:this,
      from,
      transforms,
      root:ROOT
    }
  });
}

GameData.prototype.findTransformsForRootComponentAndSource = function ({c,source,from}) {
  const filterByCids = this.filterTransformsByCid([c.id]);
  return this.recursivelyFilterTransforms(from, filterByCids);
}

GameData.prototype.recursivelyFilterTransforms = function (parent, flter, lst=[]) {
  (parent.transforms || parent.children).forEach( (t) => {
    if (flter(t)) {
      lst.push(t);
    }

    this.recursivelyFilterTransforms(t, flter, lst);

  });
  return lst;
}
GameData.prototype.findTransformsByCid = function (cid) {
  return this.findAllTransforms().filter( (t) => {
    return t.cid === cid;
  });
}

GameData.prototype.findTransformForComponent = function ({source, from, c}) {
  const roots = this.findRootComponents({source,from,c});

  const cids = map(roots, "id");
  const filterByCids = this.filterTransformsByCid(cids);
  const transforms = this.recursivelyFilterTransforms(from, filterByCids);

  return transforms;
}

GameData.prototype.getToyById = function (id) {
  const toy = this.gamedata.toybox.filter( (toy) => {
    return toy.id === id;
  })[0];
  if (!toy) {
    return null;
  }
  return {
    source:'toy',
    from:toy,
    transforms:toy.transforms,
    gamedata:this,
    root:ROOT
  }
}


export default GameData;

